<template>
  <BasicModal
    :title="title"
    :isShowModal=isShowModal
    :canCancel="true"
    @cancel="cancel">
    <div class="star-rate" v-if="!isFinishComment">
      <div style="font-size: 18px; margin-top: 10px">
        <p>今後のロボ改善のために、よろしければ評価をお願いします。</p>
        <div @mouseover="isOverModifyArea=true" @mouseleave="isOverModifyArea=false">
          <star-rating
            style="font-size: 30px; margin-top: 10px; color: yellow;"
            :increment="1.0"
            v-model="answerData['star_value']"
            :star-size="40"
            :show-rating="false"
            :padding=20
          />
        </div>
      </div>
    </div>
    <div class="star-rate" v-else>
      <div style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">
        <p>ご協力頂き、ありがとうございました。</p>
      </div>
    </div>
    <div class="comment-area"  v-if="!isFinishComment">
      <div style="font-size: 14px">
        <p>ご意見・ご要望等ございましたら、下記にご記入ください。</p>
        <textarea
          style="min-height: 88px;"
          class="textarea"
          placeholder="コメントを入力"
          maxlength="500"
          cols=100
          v-model="answerData['comment']"
        />
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box" v-if="!isFinishComment">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="saveQuestionnaire()">保存する</button>
    </div>
    <div class="footer-box" v-else>
      <button class="button" @click="cancel">閉じる</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import StarRating        from 'vue-star-rating'

export default {
  components: {
    BasicModal,
    StarRating
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    bot_id: {
      type: String,
      required: false,
      default: ""
    },
    seeker_id: {
      type: String,
      required: false,
      default: ""
    },
    company_id: {
      type: String,
      required: false,
      default: ""
    }
  },
  data () {
    return {
      isOverModifyArea: false,
      answerData: {
        chatbot: "",
        chatbot_mini: "",
        seeker: "",
        company: "",
        star_value: 0,
        comment: ""
      },
      title: "ロボ会話アンケート",
      isFinishComment: false
    }
  }, 
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    async saveQuestionnaire () {
      if (this.answerData['star_value'] !== 0 || this.answerData['comment'] !== "") {
        this.answerData['chatbot'] = this.bot_id
        this.answerData['seeker'] = this.seeker_id
        this.answerData['company'] = this.company_id

        await this.$store.dispatch('chatbot/createChatBotQuestionnaire', this.answerData)
      }

      this.isFinishComment = true
    }
  }
}
</script>

<style lang="scss" scoped>
.star-rate {
  margin-left: 10px;
  display: flex;
  align-items: center;
  overflow: auto;
  section {
    width: 100%;
  }
}
.comment-area {
  padding: 10px;
  display: flex;
  align-items: center;
  overflow: auto;
  section {
    width: 100%;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ModalChatBotQuestionnaire.vue